var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessesActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 16,
    fill: "#E4FD3D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_115_346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9995 16.0013H12.9995C11.3427 16.0013 9.99951 17.3444 9.99951 19.0013V33.0013C9.99951 34.6581 11.3427 36.0013 12.9995 36.0013H34.9995C36.6564 36.0013 37.9995 34.6581 37.9995 33.0013V19.0013C37.9995 17.3444 36.6564 16.0013 34.9995 16.0013Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0007 16.0009V14.0009C17.0007 13.4704 17.2114 12.9617 17.5865 12.5866C17.9616 12.2116 18.4703 12.0009 19.0007 12.0009H29.0007C29.5312 12.0009 30.0399 12.2116 30.4149 12.5866C30.79 12.9617 31.0007 13.4704 31.0007 14.0009V16.0009",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9995 23.0005H9.99951",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0003 23.0005V24.5007C28.0003 24.6334 27.9476 24.7606 27.8538 24.8543C27.76 24.9481 27.6328 25.0008 27.5002 25.0008H20.4992C20.3666 25.0008 20.2394 24.9481 20.1456 24.8543C20.0518 24.7606 19.9991 24.6334 19.9991 24.5007V23.0005",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115_346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessesActive);
export default __webpack_public_path__ + "static/media/businesses-active.56f22ae4a5b3ccf7fa8099bcfd0e34a0.svg";
export { ForwardRef as ReactComponent };